"use client";

import Image from "next/image";
import { SectionLayout } from "@/components/layout/SectionLayout";
import heroBackground from "@/assets/images/hero-background.png";
import { PrimaryButton } from "@/components/buttons/PrimaryButton";
import { TertiaryButton } from "@/components/buttons/TertiaryButton";
import { ScrollingBannerSection } from "@/components/sections/ScrollingBannerSection";

interface PrivatePartner {
  id: number;
  key: string;
  image: string;
  alt: string;
  description?: string;
  link?: string;
}

interface HeroSectionProps {
  privatePartners: PrivatePartner[];
}

export function HeroSection({ privatePartners }: HeroSectionProps) {
  return (
    <div>
      <SectionLayout
        className="relative min-h-[100svh] lg:min-h-[95dvh] overflow-hidden pt-[152px] lg:pt-[170px] touch-pan-y overscroll-contain"
        noPaddingX
        noPaddingY
      >
        <Image
          src={heroBackground}
          alt=""
          fill
          priority
          className="absolute inset-0 -z-20 object-cover pointer-events-none select-none"
          draggable={false}
          style={{
            transform: "translate3d(0,0,0)",
            backfaceVisibility: "hidden",
            willChange: "transform",
          }}
        />

        <div className="relative flex flex-col items-center  px-6 text-center justify-center">
          <div className="flex flex-col">
            <p className="text-4xl xs:text-5xl sm:text-6xl  md:text-[75px] lg:text-[108px] xl:text-[144px] leading-[1.1] lg:leading-[1.05] xl:leading-[1.05] 2xl:leading-[120px] tracking-[-0.02em] font-bold italic text-primary">
              Le{" "}
              <span className="relative inline-block z-0 before:content-[''] before:absolute before:inset-y-0 before:-left-[0.06em] before:-right-[0.2em] before:bg-tertiary before:-skew-x-12 before:-z-10 mx-4 lg:mr-6 xl:mr-8">
                plaisir
              </span>
              de jouer avant tout
            </p>
            <div className="text-center justify-center items-center flex flex-col gap-8  mt-6">
              <p className="text-base text-sm sm:text-base lg:text-2xl max-w-lg lg:max-w-3xl font-light">
                Rejoins le TCAB : un club vivant, des infrastructures modernes
                et une passion commune, le tennis.
              </p>
              <div className="flex flex-row  gap-12 md:gap-24 flex-wrap justify-center">
                <PrimaryButton text="Devenir membre" navigateTo="/#tarifs" />
                <TertiaryButton
                  text="Découvrir le club"
                  navigateTo="/#notre-club"
                />
              </div>
            </div>
          </div>
        </div>
      </SectionLayout>

      <ScrollingBannerSection partners={privatePartners} />
    </div>
  );
}
